import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-company-show',
  templateUrl: './company-show.component.html',
  styleUrls: ['./company-show.component.scss']
})
export class CompanyShowComponent implements OnInit {

  @Input() company:any;

  constructor(public translateService:TranslateService) { }

  ngOnInit() {
  }

}
